import { Link } from 'react-router-dom';
import { ChevronRight, Lock } from 'lucide-react';

export const CategoryCard = ({ category, index = 0, comingSoon = false }) => {
  const Wrapper = comingSoon ? 'div' : Link;
  const wrapperProps = comingSoon 
    ? {} 
    : { to: `/library/${category.slug}` };

  return (
    <Wrapper
      {...wrapperProps}
      className={`group relative block rounded-2xl overflow-hidden h-48 md:h-56 animate-fade-in ${comingSoon ? 'cursor-default' : ''}`}
      style={{ animationDelay: `${index * 0.1}s`, opacity: 0, animationFillMode: 'forwards' }}
      data-testid={`category-card-${category.slug}`}
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={category.image_url}
          alt={category.name}
          className={`w-full h-full object-cover transition-transform duration-700 ${comingSoon ? 'grayscale-[40%]' : 'group-hover:scale-110'}`}
          loading="lazy"
        />
      </div>

      {/* Gradient Overlay - Always visible */}
      <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/60 to-transparent" />

      {/* Coming Soon Badge */}
      {comingSoon && (
        <div className="absolute top-3 right-3 z-20 flex items-center gap-1.5 bg-zinc-900/80 backdrop-blur-sm border border-white/10 rounded-full px-3 py-1.5">
          <Lock className="w-3 h-3 text-amber-400" />
          <span className="text-xs font-medium text-amber-400">Coming Soon</span>
        </div>
      )}

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-end p-5 z-10">
        <h3 className="text-xl md:text-2xl font-serif text-white mb-1 group-hover:translate-x-1 transition-transform duration-300">
          {category.name}
        </h3>
        <p className="text-sm text-zinc-400 line-clamp-2 mb-3">
          {category.description}
        </p>
        {!comingSoon && (
          <div className="flex items-center gap-1 text-violet-400 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <span>Explore</span>
            <ChevronRight className="w-4 h-4" />
          </div>
        )}
      </div>

      {/* Hover glow effect */}
      {!comingSoon && (
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
          <div className="absolute inset-0 bg-gradient-to-t from-violet-900/30 to-transparent" />
        </div>
      )}
    </Wrapper>
  );
};

export default CategoryCard;
